import pluck from '../utilities/pluck';

const selectVolume = pluck('volume');

export default selectVolume;
